import { render, staticRenderFns } from "./cooperate.vue?vue&type=template&id=1d42955b"
import script from "./cooperate.vue?vue&type=script&lang=js"
export * from "./cooperate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports